// src/components/Layout/Layout.jsx
import React, { useState, useEffect } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import LoadingSpinner from '../LoadingSpinner';

const Layout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 100);

    const checkScreenSize = () => {
      const mobile = window.innerWidth < 992;
      setIsMobile(mobile);

      if (mobile) {
        setSidebarOpen(false);
      } else {
        setSidebarOpen(true);
      }
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => {
      window.removeEventListener('resize', checkScreenSize);
      clearTimeout(timer);
    };
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(prev => !prev);
  };

  // ✅ CLOSE SIDEBAR ON MOBILE CLICK
  const handleSidebarLinkClick = () => {
    if (window.innerWidth < 992) {
      setSidebarOpen(false);
    }
  };

  if (isLoading) {
    return <LoadingSpinner fullPage />;
  }

  return (
    <main className={`admin-main ${!sidebarOpen ? 'aside-small-section' : ''}`}>
      <Sidebar  isCollapsed={!sidebarOpen} onLinkClick={handleSidebarLinkClick} />
      <section className="right-section">
        <Header toggleSidebar={toggleSidebar} isCollapsed={!sidebarOpen} />
        <div className="main-page">
          {children}
        </div>
      </section>
    </main>
  );
};

export default Layout;